import React, { useEffect, useState } from 'react';
import { DateTime } from 'luxon';
import SpotlightHeader from '../../Common/Header';
import BottomBar from '../../../components/BottomBar';
import './Celebration.scss';
import { getOrdinalSuffixedNumber } from '../../helpers/boh_spotlights';
const STORAGE_KEYS = {
  boh_type_birthday: 'birthday-employee-index',
  boh_type_anniversary: 'anniversary-employee-index'
};
const getEmployee = (employees, storage_key) => {
  const nextIndex = (+localStorage.getItem(storage_key) + 1) % employees.length;
  localStorage.setItem(storage_key, nextIndex);
  return employees[nextIndex];
};
const formatBirthday = birthday => {
  if (!birthday) return '';
  const date = DateTime.fromFormat(birthday, 'MM-dd');
  const ordinal_suffixed_number = getOrdinalSuffixedNumber(date.day);
  return `${date.toFormat('MMMM')} ${ordinal_suffixed_number}`;
};
const formatAnniversary = anniversary => {
  if (!anniversary) return 'Happy Anniversary!';
  const anniversaryDate = DateTime.fromFormat(anniversary, 'yyyy-MM-dd');
  const difference = Math.abs(anniversaryDate.diffNow('years').years);
  const ordinal_suffixed_number = getOrdinalSuffixedNumber(Math.round(difference));
  return `Happy ${ordinal_suffixed_number} Anniversary!`;
};
function useEmployee(storage_key, data, metadata, type) {
  const [currentEmployee, setCurrentEmployee] = useState(null);
  useEffect(() => {
    if (!!(data !== null && data !== void 0 && data.employees) && (!currentEmployee || currentEmployee.name === 'N/A')) {
      setCurrentEmployee(getEmployee(data.employees, storage_key));
    }
  }, [data, currentEmployee, storage_key, metadata.boh_employee, type]);
  return type.includes('single_employee') ? metadata.boh_employee : currentEmployee;
}
const Celebration = props => {
  const {
    metadata,
    bohStyle,
    text,
    data,
    type
  } = props;
  const storage_key = STORAGE_KEYS[type];
  const hide_poweredbyupshow = metadata.hide_poweredbyupshow;
  const showBirthDate = (metadata === null || metadata === void 0 ? void 0 : metadata.boh_show_birth_date) && (type === 'boh_type_birthday' || type === 'boh_type_birthday_single_employee');
  const showAnniversary = (metadata === null || metadata === void 0 ? void 0 : metadata.boh_show_anniversary) && (type === 'boh_type_anniversary' || type === 'boh_type_anniversary_single_employee');
  const currentEmployee = useEmployee(storage_key, data, metadata, type);
  const formattedTitle = showAnniversary && !!currentEmployee ? {
    ...text,
    title: formatAnniversary(currentEmployee.start_date)
  } : text;
  const {
    accent_color,
    text_accent_color,
    containerStyle
  } = bohStyle;
  return /*#__PURE__*/React.createElement("div", {
    className: "celebration-container",
    style: containerStyle
  }, /*#__PURE__*/React.createElement(SpotlightHeader, {
    text: formattedTitle,
    metadata: metadata
  }), /*#__PURE__*/React.createElement("div", {
    className: "celebration-info-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "celebration-info"
  }, !!currentEmployee && /*#__PURE__*/React.createElement("div", {
    className: "celebration-info-title"
  }, /*#__PURE__*/React.createElement("div", null, currentEmployee.name), /*#__PURE__*/React.createElement("div", null, showBirthDate && formatBirthday(currentEmployee.birthday))))), /*#__PURE__*/React.createElement(BottomBar, {
    accent_color: accent_color,
    accent_text_color: text_accent_color,
    hide_poweredbyupshow: hide_poweredbyupshow
  }));
};
export default Celebration;